import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import COPY from './copy';

import { switchAndSave } from '../../helpers';
import { Packages, ROOT_PRICING_ROUTE } from '~shared/constants/pricing';
import { usePricingState } from '~shared/hooks/usePricingState';
import useTrackingDetails from '~app/pages/Pricing/hooks/useTrackingDetails';

export default function IncludedLink({ packageName }: Readonly<{ packageName: Packages }>): React.ReactElement {
  const { dispatch } = usePricingState();
  const { pageName } = useTrackingDetails();

  const copy =
    packageName === Packages.AdvantageMonthly
      ? COPY.BUSINESS_PLANS_LINK_MONTHLY.defaultMessage
      : COPY.BUSINESS_PLANS_LINK.defaultMessage;
  const isAdvantagePackage = [Packages.AdvantageAnnual, Packages.AdvantageMonthly, Packages.TeamAdvantage].includes(
    packageName
  );
  const isPremierPackage = [Packages.PremierAnnual, Packages.TeamPremier].includes(packageName);

  const handleClick = (event: SyntheticEvent): void => {
    event.preventDefault();
    switchAndSave({ numberOfUsers: '3', isAdvantagePackage, isPremierPackage, dispatch, pageName, packageName });
  };

  return (
    <Link to={`${ROOT_PRICING_ROUTE}/details`} onClick={handleClick}>
      {copy}
    </Link>
  );
}
